import { Component, ViewChild, EventEmitter, Output } from "@angular/core";
import { ModalComponent } from "../../../components/modal/modal.component";

@Component({
  selector: "lowy-reset-search-filters",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Reset All</div>
        <div class="subheading">
          Reset patient IDs, columns, and all filters.
        </div>

        <div class="button-row">
          <span (click)="cancel()">cancel</span>
          <span (click)="reset()">reset</span>
        </div>
      </div>
    </lowy-modal>
  `,
  styles: [
    `
      .seperator {
        margin-bottom: 15px;
      }
    `,
  ],
})
export class ResetFiltersModalComponent {
  @ViewChild("modal") modal: ModalComponent;

  @Output() doReset: EventEmitter<null>;

  constructor() {
    this.doReset = new EventEmitter();
  }

  public open() {
    this.modal.open();
  }

  reset() {
    this.doReset.emit();
    this.modal.close();
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/search-modals/reset-filters-modal.component.ts